export const LEGACY_APPLICATION_SHOW_ROUTE = 'authenticated.tas.applications.show';

// The three guided groups that have a `manage` child route. Values match the
// typeClassifications handled in `app/routes/authenticated/tas/applications/show.ts`'s
// afterModel routeMappings (which route every application to its `-guided` variant) —
// this map is a direct type→group lookup since `manage` only exists on the guided variant.
const GUIDED_GROUP_BY_TYPE: Record<string, string> = {
  'TAS.ProgramType.2': 'type-two-guided',
  'TAS.ProgramType.3': 'type-three-guided',
  'TAS.ProgramType.4.2': 'type-four-guided',
  'TAS.ProgramType.4.3': 'type-four-guided',
};

/**
 * Resolves the route for viewing an existing TAS application: the `manage`
 * screen when `tasCourseManagement` is on and the application's program type
 * maps to one of the three guided groups, otherwise the legacy show route.
 */
export function applicationDetailRoute(
  typeClassification: string | null | undefined,
  isManageScreenEnabled: boolean
): string {
  if (!isManageScreenEnabled) {
    return LEGACY_APPLICATION_SHOW_ROUTE;
  }
  const guidedGroup = typeClassification ? GUIDED_GROUP_BY_TYPE[typeClassification] : undefined;
  return guidedGroup
    ? `authenticated.tas.applications.${guidedGroup}.manage`
    : LEGACY_APPLICATION_SHOW_ROUTE;
}
